export default __webpack_public_path__ + "static/media/b6.36fca949.jpg";